import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchWarehouseDetail(id) {
  const { data: raw } = await request.get(`/system/warehouse/${id}`);
  return parseVer4DetailResponse(raw);
}
